const AUTH_CODE_QUERY_PARAM = "code";

/**
 * Given a URL search string, checks if it contains a valid auth code when redirected from the auth page of Kinde.
 * The code is valid if it is present and not empty, and if the URL does not contain an "error" query parameter.
 * @param search the URL search string
 * @returns true if the code is valid, false otherwise
 */

export const hasValidAuthCode = (search: string): boolean => {
  const params = new URLSearchParams(search);
  // check if the URL contains a valid auth code when redirected from the auth page of Kinde
  const code = params.get(AUTH_CODE_QUERY_PARAM);

  if (!code || code.trim() === "") {
    return false;
  }

  if (params.has("error")) {
    return false;
  }

  return true;
};
